<priva-form-group [hasLabel]="false" [hasHelp]="false" [isInline]="true">
    <span class="product-box-label">{{ 'GENERAL.TITLE.BOX' | translate }}</span>
    <select
        priva-select
        class="product-box-select"
        placeholder="Select product box"
        *ngrxLet="productBoxes$ | async as productBoxes"
        [options]="productBoxes?.privaSelectOption || []"
        [formControl]="productBoxControl"
        data-test="product-box-select"
    ></select>
</priva-form-group>
